/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_BlocklistInputs */

const en_save_blocklist = /** @type {(inputs: Save_BlocklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Blocklist`)
};

const es_save_blocklist = /** @type {(inputs: Save_BlocklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar bloqueo`)
};

/**
* | output |
* | --- |
* | "Save Blocklist" |
*
* @param {Save_BlocklistInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const save_blocklist = /** @type {((inputs?: Save_BlocklistInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_BlocklistInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_blocklist(inputs)
	return es_save_blocklist(inputs)
});